import React from 'react';
import './Skeleton.css';

const Skeleton = ({ style = {}, className = '', variant = 'line', width = '100%', height = 12, circleSize }) => {
  const baseClasses = `skeleton ${className}`.trim();
  const computedStyle = { width, height, ...style };
  const variantClass = variant === 'circle' ? 'skeleton-circle' : 'skeleton-line';
  if (variant === 'circle' && circleSize) {
    computedStyle.width = circleSize;
    computedStyle.height = circleSize;
  }

  return <div className={`${baseClasses} ${variantClass}`} style={computedStyle} />;
};

export default Skeleton;

